<template>
  <ModalStep
    id="mentee-matching-loading"
    :header="{
      title: t('matching.menteeMatchingLoading.title'),
    }"
  >
    <template #headerBeforeElement>
      <ProgramReminder :programId="selectedProgramIdRef" />
    </template>
    <template #bodyContent>
      <div class="mentee-matching-loading-step">
        <LoadingIcon color="primary" />
        <div class="mentee-matching-loading-step__bar">
          <div
            :key="currentStep"
            class="mentee-matching-loading-step__bar-fill"
            :style="{ animationDuration: `${stepDurations[currentStep]}ms` }"
          />
        </div>
        <p :key="currentStep" class="mentee-matching-loading-step__label">
          {{ t(`matching.menteeMatchingLoading.steps.${currentStep}` as Parameters<typeof t>[0]) }}
        </p>
      </div>
    </template>
  </ModalStep>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue'

import ProgramReminder from '@/features/programs/components/program-reminder/program-reminder.vue'
import { selectGetSelectedProgramId } from '@/features/programs/stores/programs/programs.selectors'
import programsStore from '@/features/programs/stores/programs/programs.store'
import LoadingIcon from '@/features/ui/components/icons/loading-icon.vue'
import ModalStep from '@/features/ui/components/modal/modal-step/modal-step.vue'
import { useI18n } from '@/lib/i18n'

const LAST_STEP_DURATION_MS = 180_000 // 3 min — avance très lentement jusqu'au résultat

const BASE_DURATIONS = [
  2500, 3000, 4000, 3500, 5000, 4500, 6000, 5500, 5000, 7000, 8000,
]

function randomize(base: number): number {
  const variance = base * 0.2
  return Math.round(base + (Math.random() * 2 - 1) * variance)
}

const stepDurations = [...BASE_DURATIONS.map(randomize), LAST_STEP_DURATION_MS]

const selectedProgramIdRef = selectGetSelectedProgramId(programsStore)

const { t } = useI18n()

const currentStep = ref(0)

let timeout: ReturnType<typeof setTimeout>

function scheduleNext() {
  if (currentStep.value >= stepDurations.length - 1) return
  timeout = setTimeout(() => {
    currentStep.value++
    scheduleNext()
  }, stepDurations[currentStep.value])
}

scheduleNext()

onBeforeUnmount(() => {
  clearTimeout(timeout)
})
</script>

<style lang="scss">
@import './mentee-matching-loading.scss';
</style>
